// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2WWpp","footer":"ChangeClinic_footer__3ocdZ"};